export enum RequesterType {
  USER = 'User',
  DEVICE = 'Device',
  SYSTEM = 'System'
}
